import React, { FC } from 'react';
import { borderedFiles } from '@/library/utils/files.ts';
import { BorderedFileType } from '@/library/types/files';
import useTooltipID from '@/library/utils/hooks/useTooltipID';
import SvgRender from '@/library/components/general/SvgRender';
import Tooltip from '@/library/components/general/Tooltip';

type ExportIconProps = {
  white?: boolean;
  onClick: () => void;
  className?: string;
  textClassname?: string;
  svgStyle?: React.CSSProperties;
  extension?: BorderedFileType;
  disabled?: boolean;
  showTooltip?: boolean;
  tooltipMessage?: string;
  text?: string;
};

const ExportIcon: FC<ExportIconProps> = ({
  white,
  onClick,
  className,
  textClassname,
  svgStyle,
  extension = '',
  disabled,
  showTooltip = false,
  tooltipMessage = 'File is processing',
  text = 'Export PDF'
}) => {
  const { avoidRender, tooltipID } = useTooltipID('export-icon-tooltip');

  if (avoidRender) return null;

  return (
    <div
      id={tooltipID || ''}
      onClick={() => (disabled ? null : onClick())}
      className={`base-transition ${
        disabled ? '' : 'cursor-pointer'
      } d-inline-flex align-items-center${disabled ? ' opacity-4' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      <SvgRender
        src={borderedFiles[extension] || ''}
        style={svgStyle || { width: 12, height: 16 }}
      />
      <span
        className={`ms-1 text-${white ? 'white' : 'primary'} lh-12 ${
          textClassname ? textClassname : 'fw-bold fs-10'
        }`}
      >
        {text}
      </span>

      {showTooltip && tooltipID ? <Tooltip target={tooltipID}>{tooltipMessage}</Tooltip> : null}
    </div>
  );
};

export default ExportIcon;
